import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "svg-play-btn" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  height: "70",
  viewbox: "0 0 106 70",
  width: "106",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3302_4031)" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      fill: "white",
      height: "69",
      opacity: "0.1",
      rx: "5",
      width: "103",
      x: "0.972656"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M52.9994 56.579C65.0021 56.579 74.7322 46.8588 74.7322 34.8684C74.7322 22.878 65.0021 13.1579 52.9994 13.1579C40.9967 13.1579 31.2666 22.878 31.2666 34.8684C31.2666 46.8588 40.9967 56.579 52.9994 56.579ZM48.0602 43.4147L62.878 34.8684L48.0602 26.3221V43.4147Z",
      fill: "white",
      "fill-rule": "evenodd"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M97.7824 70H7.9535C4.13379 70 0.972656 66.8421 0.972656 63.0263V7.10526C0.972656 3.15789 4.13379 0 8.08521 0H97.6507C101.602 0 104.895 3.28947 104.895 7.23684V62.7632C105.027 66.7105 101.734 70 97.7824 70ZM8.08521 1.31579C4.92408 1.31579 2.2898 3.94737 2.2898 7.10526V63.0263C2.2898 66.1842 4.79236 68.6842 7.9535 68.6842H97.7824C101.075 68.6842 103.71 66.0526 103.71 62.7632V7.23684C103.71 3.94737 100.944 1.31579 97.7824 1.31579H8.08521Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3302_4031" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        fill: "white",
        height: "70",
        transform: "translate(0.972656)",
        width: "104.054"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}